<template>
    <div>
        <div style="background-color: white;">
            <van-image width="100%" height="auto" :src="product.image || product.prodImage" style="min-height: 80px"/>
            <div style="background-color: white; margin: 0 20px; box-shadow:0px 2px 6px 0px rgba(194,194,194,0.5); border-radius:4px; position: relative; top: -30px; display: flex; flex-direction: column; align-items: center; overflow: hidden;">
                <div style="margin: 18px 0 9px 0; font-size: 18px; color: #066BEE; font-weight: bold; text-align: center;">
                    {{product.prodName}}
                </div>
                <div style="box-sizing: border-box; color: white; width: 100%; padding: 10px; background:linear-gradient(270deg,rgba(64,182,248,1) 0%,rgba(69,135,221,1) 100%);">
                    {{product.prodDescribe}}
                </div>
            </div>
        </div>
        <div style="margin-top: 10px; background-color: white;">
            <div style="padding: 10px 20px; border-bottom: 1px #F5F5F5 solid;">{{product.prodType === '1' ? '体检产品介绍' :
                '保障计划'}}
            </div>
            <div v-html="product.prodContent" class="productContent"/>
        </div>
        <div style="margin-top: 10px; background-color: white;">
            <van-tabs v-model="active" swipeable animated sticky color="#1989fa" line-height="2px">
                <van-tab title="产品介绍">
                    <div v-html="product.prodSht" class="productContent"/>
                </van-tab>
                <van-tab :title="product.prodType === '1' ? '参检流程与说明' : '理赔须知'">
                    <div v-html="product.claimsFlow" class="productContent"/>
                </van-tab>
                <van-tab :title="product.prodType === '1' ? '我要参检' : '我要投保'">
                    <div v-if="product.prodType === '1'"
                         style="display: flex; flex-direction: column; padding: 15px 20px; font-size: 14px">
                        <div style="margin-bottom: 6px;">请选择产品类型：</div>
                        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
                            <div v-for="item in product.prodPrice" class="item" :key="item.priceId"
                                 :class="{selectItem: selectedPrice.priceId === item.priceId}"
                                 @click="selectedPriceClick(item)">
                                {{item.priceType}}
                            </div>
                        </div>
                        <div style="padding: 10px 0 5px;">产品名称：<span
                                style="float: right;">{{selectedPrice.priceType}}</span></div>
                        <div style="padding: 5px 0;">产品单价：<span style="float: right;">{{selectedPrice.price}}</span>
                        </div>
                        <div style="padding: 5px 0; display: flex; align-items: center; justify-content: space-between;">
                            <div>购买数量：</div>
                            <van-stepper v-model="numberValue" step="1"/>
                        </div>
                    </div>
                    <div v-else style="padding: 20px;">
                        <div>投保咨询电话：</div>
                        <span style="color: #333333">益小宝 </span>
                        <a href="tel:010-86464262" style="flex:1; color: #1D8FE1">010-86464262</a>
                        <span style="color: #333333">或</span>
                        <a href="17710915695" style="flex:1; color: #1D8FE1">17710915695</a>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
        <div style="margin-top: 10px; background-color: white; margin-bottom: 53px;">
            <div style="display: flex; flex-direction: column; align-items: center; padding: 17px 0;">
                <div style="display: flex; align-items: center;">
                    <img src="@/assets/yibao-logo.png" width="auto" height="30px"
                         style="margin-right: 10px; padding-bottom: 3px;">
                </div>
                <div style="font: 10px normal; color: #999999; margin-top: 6px;">中国公益人和中低收入人群普惠保险平台</div>
            </div>
        </div>
        <div style="position: fixed; bottom: 0; left: 0; right: 0; display: flex; text-align: center;">
            <div style="flex: 1; background-color: white; padding: 10px 0; color: #666666;" @click="active = 2">
                {{product.prodType === '1' ? '参检详询' : '投保详询'}}
            </div>
            <div v-if="product.jumpConnection || product.prodType === '1'"
                 style="flex: 1; background-color: #1989fa; padding: 10px 0; color: white;" @click="buy">
                {{product.prodType === '1' ? '立即参检' : '立即投保'}}
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image, Tab, Tabs, Stepper} from 'vant';
    import {wxChatShare} from '@/utils/wxShare'
    import Cookies from "js-cookie";

    Vue.use(Image).use(Tab).use(Tabs).use(Stepper);
    export default {
        name: "ProductDetail",
        data() {
            return {
                type: Cookies.get('type'),
                user: this.$store.state.user.user,
                active: 0,
                id: this.$route.query.id || '',
                product: {},
                selectedPrice: {},
                numberValue: 1
            }
        },
        created() {
            this.$axios.get('product/info', {params: {productId: this.id,shareId: Cookies.get('shareId')}}).then((res) => {
                this.product = res.data;
                if (this.product.prodPrice.length > 0) {
                    this.selectedPrice = res.data.prodPrice[0]
                }
                this.settingShare()
            })
        },
        methods: {
            settingShare() {
                let name = this.user.userName || this.user.loginName
                let title = `向您推荐了益宝公益产品（${this.product.prodName}）`
                let param = {
                    url: window.location.href.split('#')[0], // 当前页面url
                    title: name + title, // 分享数据配置 主标题
                    desc: this.product.prodDescribe, // 分享数据配置 副标题
                    link: process.env.VUE_APP_SHARE_URL + '/productDetail?shareId=' + this.user.userId + '&type=' + this.type + '&id=' + this.product.productId, // 分享数据配置
                    imgUrl: this.product.image || this.product.prodImage || 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/fc038003a2ec7ae47b3bd2480f18ead5.png', // 分享数据配置 －－ 全路径
                    type: "link", // 分享类型,music、video或link，不填默认为link
                    dataUrl: " ", // 如果type是music或video，则要提供数据链接，默认为空
                }
                wxChatShare(param);
            },
            buy() {
                if (this.product.prodType === '1') {//体检
                    if (this.active != 2) {
                        this.active = 2;
                        window.scrollTo(0, document.documentElement.clientHeight);
                        return;
                    }
                    if (this.selectedPrice.priceId) {
                        this.$router.push({
                            path: '/buy',
                            query: {
                                number: this.numberValue,
                                productId: this.id,
                                price: this.selectedPrice.price,
                                priceId: this.selectedPrice.priceId
                            }
                        })
                    } else {
                        this.$toast({message: '请选择要投保的产品', duration: 700});
                    }
                } else {
                    window.location.href = this.product.jumpConnection
                }
            },
            selectedPriceClick(item) {
                this.selectedPrice = item
            }
        }
    }
</script>

<style scoped>
    .productContent {
        font-size: 14px;
        padding: 20px;
    }

    .productContent img {
        box-sizing: border-box;
        width: 100%;
    }

    .item {
        border: #cccccc 1px solid;
        color: #323233;
        padding: 2px 5px;
        border-radius: 3px;
    }

    .selectItem {
        border: #35a1f4 1px solid;
        background-color: #1989fa;
        color: white;
    }
</style>
